export * from '@taqueria/protocol/out/types/NetworkAccountConfig';
